import { studentsStore } from './studentsStore'
import {
	fetchOrganizationStudents,
	mapBackendStudentToFrontend,
} from 'api/users'

let inflight = null

function studentsNeedAvatarRefresh(students) {
	if (!students?.length) return true
	// Refetch when list was loaded before avatar fields existed (e.g. HMR / old API).
	return students.some(s => !s?.avatarKey)
}

function studentsNeedUserManagementFields(students) {
	if (!students?.length) return false
	return students.some(
		s => s?.assignmentsCount == null || s?.kandorPlan == null || s?.counselorId === undefined,
	)
}

export async function ensureStudentsLoaded({ force = false } = {}) {
	if (
		!force &&
		studentsStore.students?.length > 0 &&
		!studentsNeedAvatarRefresh(studentsStore.students) &&
		!studentsNeedUserManagementFields(studentsStore.students)
	) {
		return studentsStore.students
	}

	// If already loading, return the existing promise to avoid race conditions
	if (inflight) {
		return inflight
	}

	// If already in loading state, don't start another request
	if (studentsStore.isLoadingStudents) {
		return inflight || Promise.resolve(studentsStore.students)
	}

	// Set loading state
	studentsStore.isLoadingStudents = true
	studentsStore.studentsLoadStatus = 'loading'

	inflight = (async () => {
		try {
			const response = await fetchOrganizationStudents()
			const backendStudents = response.students || []
			const mapped = backendStudents.map((s, i) =>
				mapBackendStudentToFrontend(s, i)
			)
			// Deduplicate by student id (keep first) so search/table never show duplicate rows
			const seen = new Set()
			const deduped = mapped.filter(s => {
				const id = String(s?.id ?? '').trim()
				if (!id || seen.has(id)) return false
				seen.add(id)
				return true
			})
			studentsStore.setStudents(deduped)
			studentsStore.studentsLoadStatus = 'success'
			return deduped
		} catch (error) {
			console.error('Error loading students:', error)
			studentsStore.studentsLoadStatus = 'error'
			throw error
		} finally {
			studentsStore.isLoadingStudents = false
			inflight = null
		}
	})()

	return inflight
}
